import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[txpNumbersOnly]',
  standalone: true,
})
export class NumbersOnlyDirective {
  // Allow key codes for special events
  // Backspace, tab, end, home
  private specialKeys: any[] = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Del',
    'Delete',
  ];

  constructor(private el: ElementRef) {}

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    this.handlePaste(event);
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Handle keyboard shortcuts (Cmd+V, Ctrl+V, Cmd+C, Ctrl+C)
    if ((event.metaKey || event.ctrlKey) && (event.key === 'v' || event.key === 'c')) {
      return;
    }

    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    const current: string = this.el.nativeElement.value;
    const isNumber = event.key !== ' ' && !isNaN(+event.key);
    const isDecimal = event.key === '.';
    const containsDecimal = current.includes('.');

    // allow numbers or a decimal if there isn't already a decimal
    // FYI: if they type 2 decimals in a row, the current value does not contain
    // the decimal so it doesn't know there is already one, but field will be invalid
    if (isNumber || (isDecimal && !containsDecimal)) {
      return;
    } else {
      event.preventDefault();
    }
  }

  private handlePaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedInput = event.clipboardData?.getData('text/plain');
    if (pastedInput) {
      // Remove non-numeric characters (except decimal point)
      const cleanedInput = pastedInput.replace(/[^0-9.]/g, '');
      // Only allow one decimal point
      const parts = cleanedInput.split('.');
      const sanitizedInput = parts[0] + (parts.length > 1 ? '.' + parts[1] : '');

      // Update the input value directly
      const input = this.el.nativeElement as HTMLInputElement;
      const start = input.selectionStart || 0;
      const end = input.selectionEnd || 0;
      const currentValue = input.value;

      input.value = currentValue.substring(0, start) + sanitizedInput + currentValue.substring(end);

      // Update cursor position
      input.setSelectionRange(start + sanitizedInput.length, start + sanitizedInput.length);

      // Trigger input event to ensure form control is updated
      input.dispatchEvent(new Event('input'));
    }
  }
}
